import { SectionRenderer } from '../components/blocks/SectionRenderer';
import { Container } from '../components/primitives/Container';
import { SectionHead } from '../components/primitives/SectionHead';
import { useContent } from '../content/load';
import { useDocumentTitle } from '../lib/seo';

export default function Docs() {
  const { pages } = useContent();
  const page = pages.docs;
  useDocumentTitle(page?.seo.title, page?.seo.description);
  if (!page) {
    return (
      <Container>
        <SectionHead
          eyebrow="DOCS"
          heading="Documentation."
          body="Real docs land in PR 07. The schema-driven content model means each section here is editable JSON."
        />
      </Container>
    );
  }
  return (
    <Container>
      {page.sections.map((s, i) => (
        <SectionRenderer key={i} section={s} />
      ))}
    </Container>
  );
}
